import { render, staticRenderFns } from "./map-popup-item.vue?vue&type=template&id=2aefa955&scoped=true&"
import script from "./map-popup-item.vue?vue&type=script&lang=js&"
export * from "./map-popup-item.vue?vue&type=script&lang=js&"
import style0 from "./map-popup-item.vue?vue&type=style&index=0&id=2aefa955&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aefa955",
  null
  
)

export default component.exports